import { Routes } from '@angular/router';
import { ContenedorPrincipal } from '@compartido/componentes/contenedor-principal/contenedor-principal';
import { autenticacionGuard } from '@nucleo/guardianes/autenticacion-guard';
import { CLAVE_DATO_PERMISOS_REQUERIDOS, permisoGuard } from '@nucleo/guardianes/permiso-guard';
import { Permiso } from '@nucleo/seguridad/permiso.enum';
import { RUTAS_APP } from './app-rutas.const';

export const rutasAplicacion: Routes = [
  //#region Rutas públicas
  {
    path: RUTAS_APP.AUTENTICACION.BASE,
    loadChildren: () =>
      import('@autenticacion/rutas/autenticacion-rutas').then((m) => m.autenticacionRutas),
  },
  //#endregion

  //#region Rutas privadas (requieren sesión; cada módulo exige además su permiso de consulta)
  {
    path: '',
    component: ContenedorPrincipal,
    canActivate: [autenticacionGuard],
    children: [
      {
        path: RUTAS_APP.FUNCIONALIDADES.INICIO,
        pathMatch: 'full',
        data: { nombre: { es: 'Inicio', en: 'Home' } },
        loadChildren: () =>
          import('@funcionalidades/inicio/rutas/inicio-rutas').then((m) => m.inicioRutas),
      },
      {
        path: RUTAS_APP.FUNCIONALIDADES.PROPIEDADES,
        data: { nombre: { es: 'Propiedades', en: 'Properties' } },
        loadChildren: () =>
          import('@funcionalidades/propiedades/rutas/propiedades-rutas').then((m) => m.propiedadesRutas),
      },
      {
        path: RUTAS_APP.FUNCIONALIDADES.FINANZAS,
        data: { nombre: { es: 'Finanzas', en: 'Finance' } },
        loadChildren: () =>
          import('@funcionalidades/finanzas/rutas/finanzas-rutas').then((m) => m.finanzasRutas),
      },
      {
        path: RUTAS_APP.FUNCIONALIDADES.COMUNICACION,
        data: { nombre: { es: 'Comunicación', en: 'Communication' } },
        loadChildren: () =>
          import('@funcionalidades/comunicacion/rutas/comunicacion-rutas').then((m) => m.comunicacionRutas),
      },
      {
        path: RUTAS_APP.FUNCIONALIDADES.RESERVAS,
        data: { nombre: { es: 'Reservas', en: 'Reservations' } },
        loadChildren: () =>
          import('@funcionalidades/reservas/rutas/reservas-rutas').then((m) => m.reservasRutas),
      },
      {
        path: RUTAS_APP.FUNCIONALIDADES.MANTENIMIENTO,
        data: { nombre: { es: 'Mantenimiento', en: 'Maintenance' } },
        loadChildren: () =>
          import('@funcionalidades/mantenimiento/rutas/mantenimiento-rutas').then((m) => m.mantenimientoRutas),
      },
      {
        path: RUTAS_APP.FUNCIONALIDADES.ACCESOS,
        data: { nombre: { es: 'Control de accesos', en: 'Access control' } },
        loadChildren: () =>
          import('@funcionalidades/accesos/rutas/accesos-rutas').then((m) => m.accesosRutas),
      },
      {
        path: RUTAS_APP.FUNCIONALIDADES.MI_HOGAR,
        data: { nombre: { es: 'Mi hogar', en: 'My home' } },
        loadChildren: () =>
          import('@funcionalidades/mi-hogar/rutas/mi-hogar-rutas').then((m) => m.miHogarRutas),
      },
      {
        path: RUTAS_APP.FUNCIONALIDADES.AUDITORIA,
        canActivate: [permisoGuard],
        data: {
          nombre: { es: 'Auditoría', en: 'Audit' },
          [CLAVE_DATO_PERMISOS_REQUERIDOS]: [Permiso.AUDITORIA_CONSULTAR],
        },
        loadChildren: () =>
          import('@funcionalidades/auditoria/rutas/auditoria-rutas').then((m) => m.auditoriaRutas),
      },
      {
        path: RUTAS_APP.FUNCIONALIDADES.SEGURIDAD,
        data: { nombre: { es: 'Seguridad', en: 'Security' } },
        loadChildren: () =>
          import('@funcionalidades/seguridad/rutas/seguridad-rutas').then((m) => m.seguridadRutas),
      },
      {
        path: RUTAS_APP.FUNCIONALIDADES.MI_PERFIL,
        data: { nombre: { es: 'Mi perfil', en: 'My profile' } },
        loadChildren: () =>
          import('@funcionalidades/mi-perfil/rutas/mi-perfil-rutas').then((m) => m.miPerfilRutas),
      },
    ],
  },
  //#endregion

  { path: '**', redirectTo: '' },
];
